import { combineEpics } from "redux-observable";
import { epicOpenOtherPlayerProfile } from "./epics/epicOpenOtherPlayerProfile";
import { epicOpenOwnPlayerProfile } from "./epics/epicOpenOwnPlayerProfile";
export var epicPlayerProfile = combineEpics(epicOpenOwnPlayerProfile, epicOpenOtherPlayerProfile);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/epicPlayerProfile.ts
// module id = 2101
// module chunks = 3